/* eslint-disable import/prefer-default-export */
export const tableHead = [{
  prop: 'name',
  label: '课件名称',
  width: '120',
}, {
  prop: 'title',
  label: '课件标题',
  width: '120',
}, {
  prop: 'category_name',
  label: '所属分类',
  width: '120',
}, {
  prop: 'type',
  label: '课件类型',
  filterType: {
    online: '线上课件',
    offline: '线下课件',
    double_teacher: '双师课件',
  },
}, {
  prop: 'created_at',
  label: '创建时间',
}, {
  prop: 'updated_at',
  label: '更新时间',
}, {
  prop: 'package_status',
  label: '发布状态',
  filterColor: {
    unpublished: {
      color: '#666',
    },
    success: {
      color: '#52C41A',
    },
    failure: {
      color: '#F5222D',
    },
  },
  filterType: {
    unpublished: '未发布',
    success: '发布成功',
    failure: '发布失败',
  },
}, {
  prop: 'school_name',
  label: '校区名称',
}, {
  prop: 'create_name',
  label: '创建人',
}, {
  prop: 'mobile',
  label: '手机号',
}, {
  prop: 'update_name',
  label: '最后修改',
}];



// WEBPACK FOOTER //
// ./src/views/CourseOn/courseList/components/fields.js